import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Cryptocurrency } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  UpdateUserSettingsCryptocurrencyMutation,
  UpdateUserSettingsCryptocurrencyMutationVariables,
} from './__generated__/useUpdateCryptocurrency.graphql.ts';

const UPDATE_USER_SETTINGS_CRYPTOCURRENCY_MUTATION = gql`
  mutation UpdateUserSettingsCryptocurrencyMutation(
    $input: updateUserSettingsInput!
  ) {
    updateUserSettings(input: $input) {
      userSettings {
        id
        cryptocurrency
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateUserSettingsCryptocurrencyMutation,
  UpdateUserSettingsCryptocurrencyMutationVariables
>;

export const useUpdateCryptocurrency = () => {
  const { currentUser } = useCurrentUserContext();
  const [mutateCryptocurrency, { loading }] = useMutation(
    UPDATE_USER_SETTINGS_CRYPTOCURRENCY_MUTATION,
    { showErrorsWithSnackNotification: true }
  );

  const updateCryptocurrency = (cryptocurrency: Cryptocurrency) => {
    mutateCryptocurrency({
      variables: {
        input: {
          cryptocurrency,
        },
      },
      optimisticResponse: {
        updateUserSettings: {
          __typename: 'updateUserSettingsPayload',
          userSettings: {
            ...currentUser!.userSettings,
            cryptocurrency,
          },
          errors: [],
        },
      },
    });
  };

  return {
    updateCryptocurrency,
    loading,
  };
};
